'use client';

import type { ReactNode } from 'react';

import { TopNavigation } from '@/app/components/layouts/top-navigation';
import { TopNavigationStyled } from '@/app/components/layouts/top-navigation/styles';
import { TOP_NAV_DATA_TEST } from '@/app/components/layouts/top-navigation/tracking';
import type {
  NavItemType,
  TopNavigationThemeType,
  TopNavigationTransparentAppearanceType,
} from '@/app/types/top-navigation';
import type { VehicleType } from '@/app/types/vehicle-type';
import { createDataAttributes } from '@/app/utils/createDataAttributes';

interface TopNavigationTransparentProps {
  logo: ReactNode;
  vehicleType: VehicleType;
  items: NavItemType[];
  theme?: TopNavigationThemeType;
  appearance?: TopNavigationTransparentAppearanceType;
  className?: string;
}

export const TopNavigationTransparent = ({
  logo,
  vehicleType = 'lcv',
  items = [],
  theme = 'light',
  appearance = 'default',
  className,
}: TopNavigationTransparentProps) => {
  return (
    <header
      className={TopNavigationStyled({
        variant: 'transparent',
        showBackground: false,
        className,
      })}
      {...createDataAttributes({
        test: TOP_NAV_DATA_TEST.header,
      })}
      data-myi-hide
    >
      <TopNavigation
        logo={logo}
        items={items}
        vehicleType={vehicleType}
        theme={theme}
        appearance={appearance}
      />
    </header>
  );
};
